import artwork from '../../../../../../assets/images/enhanced_event_demo/bath-rugby-artwork.png';
import secondaryLogo from '../../../../../../assets/images/enhanced_event_demo/bath-rugby-logo.png';
import venueMap from '../../../../../../assets/images/enhanced_event_demo/bath-rugby-venue-map.png';
import mapIcon from '../../../../../../assets/images/enhanced_event_demo/map-icon.png';
import eventGuideIcon from '../../../../../../assets/images/enhanced_event_demo/event-guide-icon.png';
import publicIcon from '../../../../../../assets/images/enhanced_event_demo/event-guide-public-icon.png';
import foodIcon from '../../../../../../assets/images/enhanced_event_demo/event-guide-food-icon.png';
import bagPolicyIcon from '../../../../../../assets/images/enhanced_event_demo/event-guide-bag-policy-icon.png';
import moreIcon from '../../../../../../assets/images/enhanced_event_demo/event-guide-more-icon.png';
import parkingMenuIcon from '../../../../../../assets/images/enhanced_event_demo/parking.svg';
import visitMenuIcon from '../../../../../../assets/images/enhanced_event_demo/visit.svg';
import merchMenuIcon from '../../../../../../assets/images/enhanced_event_demo/merch.svg';
import accessMenuIcon from '../../../../../../assets/images/enhanced_event_demo/access.svg';
import addOnMenuIcon from '../../../../../../assets/images/enhanced_event_demo/add-on.svg';
import phoneMenuIcon from '../../../../../../assets/images/enhanced_event_demo/phone.svg';
import emailMenuIcon from '../../../../../../assets/images/enhanced_event_demo/email.svg';
import websiteMenuIcon from '../../../../../../assets/images/enhanced_event_demo/website.svg';

export const POSTER_DEMO_IMAGES = {
  artwork,
  secondaryLogo,
  venueMap,
} as const;

export const POSTER_DEMO_ICONS = {
  map: mapIcon,
  eventGuide: eventGuideIcon,
  food: foodIcon,
  bagPolicy: bagPolicyIcon,
  public: publicIcon,
  more: moreIcon,
} as const;

export const POSTER_DEMO_MENU_ICONS = {
  parking: parkingMenuIcon,
  visit: visitMenuIcon,
  merch: merchMenuIcon,
  access: accessMenuIcon,
  addOn: addOnMenuIcon,
  phone: phoneMenuIcon,
  email: emailMenuIcon,
  website: websiteMenuIcon,
} as const;
